export default __webpack_public_path__ + "static/media/stationsExpress.eb02778a.jpg";